import React from "react";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Cell
} from "recharts";

import {
    DEPARTMENT_COLORS,
    DEFAULT_COLOR
} from "../../utils/departmentColors";

const AwaitingBarChart = ({ data }) => {

    // ✅ Merge same departments
    const departmentMap = {};

    data.forEach(item => {
        const dept = item.Department;
        const count = Number(item.count);

        if (!departmentMap[dept]) {
            departmentMap[dept] = 0;
        }

        departmentMap[dept] += count;
    });

    const formattedData = Object.entries(departmentMap).map(
        ([name, value]) => ({
            name,
            value
        })
    );

    // ✅ Total
    const total = formattedData.reduce(
        (sum, item) => sum + item.value,
        0
    );

    return (
        <div style={{ width: "100%", height: 400 }}>
            <h3>
                Awaiting Students (Total: {total})
            </h3>

            <ResponsiveContainer>
                <BarChart
                    data={formattedData}
                    margin={{
                        top: 20,
                        right: 20,
                        left: 0,
                        bottom: 80
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />

                    <XAxis
                        dataKey="name"
                        angle={-25}
                        textAnchor="end"
                        interval={0}
                    />

                    <YAxis />

                    <Tooltip />

                    <Bar
                        dataKey="value"
                        radius={[6, 6, 0, 0]}
                    >
                        {formattedData.map((entry, index) => (
                            <Cell
                                key={index}
                                fill={
                                    DEPARTMENT_COLORS[entry.name] ||
                                    DEFAULT_COLOR
                                }
                            />
                        ))}
                    </Bar>

                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};

export default AwaitingBarChart;